import {err, ok, ValidationError} from 'framework';
import type {Result, Validator} from 'framework';
import {z} from 'zod';
import {
  betterAuthErrorSchema,
  betterAuthSessionResponseSchema,
} from './better-auth-response.schemas';

const signInResponseSchema = z.object({
  data: betterAuthSessionResponseSchema.nullish(),
  error: betterAuthErrorSchema.nullish(),
});

export type BetterAuthSignInResponse = z.output<typeof signInResponseSchema>;

export class BetterAuthSignInResponseValidator implements Validator<BetterAuthSignInResponse> {
  readonly standardSchema = signInResponseSchema;

  validate(value: unknown): Result<BetterAuthSignInResponse, ValidationError> {
    const parsed = this.standardSchema.safeParse(value);

    if (!parsed.success) {
      return err(
        new ValidationError(
          parsed.error.issues[0]?.message ?? 'Unexpected sign-in response shape.',
        ),
      );
    }

    return ok(parsed.data);
  }
}
